import React from "react";

import { Button } from "aible";

import moment from "moment";

import NumericLabel from "react-pretty-numbers";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";

import RunPlot from "containers/RunPlot/RunPlot";
import ModelTileContainer from "containers/Tiles/ModelTile";
import FeatureChartContainer from "containers/FeatureChart/FeatureChart";
import MiniContainer from "containers/Results/Mini";

import SuccessResults from "components/CreateWizard/Success/SuccessResults";
import DeployStep from "components/CreateWizard/Success/DeployStep";

import AibleStep from "components/CreateWizard/AibleStep";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import ResultsGraph from "components/Results/ResultsGraph";
import ModelError from "components/Results/ModelError";

import ProjectHelpContainer from "containers/UnifiedProject/Help/ProjectHelp";
import ProjectHelpItem from "components/UnifiedProject/Help/ProjectHelpItem";

import ModelLoadingIndicator from "containers/Results/ModelLoadingIndicator";
import MetaDataTable from "components/FeatureChart/MetaDataTable";

import styles from "./style.module.css";

export const SECTIONS = {
  OVERVIEW: "Overview",
  RESULTS: "Results",
  ROI_CHART: "ROI Chart",
  MODEL_PLOTS: "Model Plots",
  PREDICTION_DRIVERS: "Prediction Drivers",
  WHAT_IF: "What If",
  MODEL_DETAILS: "Model Details"
};

export default class AcademicEvaluation extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  generateFids() {
    let ids = this.props.frontierModels && this.props.frontierModels.map((a) => a.id);
    return new Set(ids);
  }

  updateSelectedTab(key) {
    const { updateOption } = this.props;

    return updateOption("selectedTab", key);
  }

  renderROIChart() {
    const { id, models, model } = this.props;

    return (
      <div className={styles.chartHolder}>
        <div className={styles.chartHolder}>
          <RunPlot forceEnableBts hideLineGraphs id={id} />
        </div>
      </div>
    );
  }

  getImpactFromModel(model) {
    const { isContinuous, isQuickRun } = this.props;

    return model
      ? model.maxIteration && model.maxIteration.displayImpact
        ? isContinuous || isQuickRun
          ? Math.abs(Math.round(model.maxIteration.displayImpact))
          : Math.round(model.maxIteration.displayImpact)
        : isContinuous || isQuickRun
          ? Math.abs(Math.round(isQuickRun ? model.meanAbsoluteError : model.checkMax))
          : Math.round(model.checkMax)
      : undefined;
  }

  getUnconstrainedImpactFromModel(model) {
    const { isContinuous, isQuickRun } = this.props;

    return model
      ? model.maxIteration && model.maxIteration.roi
        ? isContinuous || isQuickRun
          ? Math.abs(Math.round(model.maxIteration.roi))
          : Math.round(model.maxIteration.roi)
        : isContinuous || isQuickRun
          ? Math.abs(Math.round(model.maxIteration.checkMax))
          : Math.round(model.checkMax)
      : undefined;
  }

  handleSectionSelect(section) {
    const { model, updateFieldSelect, fieldSelect } = this.props;

    if (section === SECTIONS.PREDICTION_DRIVERS) {
      if (fieldSelect === undefined && model && model.featureInfo && model.featureInfo.length > 0) {
        updateFieldSelect(model.featureInfo[0].label);
      }
    }

    return this.updateSelectedTab(section);
  }

  renderPredictions() {
    const { id, models } = this.props;

    return (
      <div className={styles.chartHolder}>
        <FeatureChartContainer
          id={id}
          label={"Select to see more information about each variable"}
          isResults
          predictMode={"drivers"}
        />
      </div>
    );
  }

  renderWhatIf() {
    const { id, models, projectId, isForecast } = this.props;

    return (
      <div className={styles.chartHolder}>
        <FeatureChartContainer
          id={id}
          isModelSelect
          predictMode={isForecast ? "forecast" : "predict"}
          projectId={projectId}
          isForecast={isForecast}
        />
      </div>
    );
  }

  renderDetails() {
    const { id, models, model, frontierModels } = this.props;

    const fids = this.generateFids();

    return <MetaDataTable models={models} fids={fids} {...this.props} />;
  }

  render() {
    const {
      id,
      isNextStep,
      models,
      model,
      optimized,
      options,
      blueprintId,
      isEditBlueprint,
      updateIsNextStep,
      isError,
      errorMessages,
      isFinalStep,
      isOverallSegment,
      project
    } = this.props;

    const fids = this.generateFids();

    if (isOverallSegment) {
      return (
        <div className={styles.optimizerEmpty}>
          <div className={styles.loading}>Select a subgroup to continue</div>
        </div>
      );
    }

    if (isError) {
      return <ModelError errors={errorMessages} />;
    }

    const projMoment = moment(project && project.created_date)
      .subtract(8, "hours")
      .add(1, "minutes");
    const currMoment = moment();

    const timeDiff = currMoment.isAfter(projMoment);

    if (optimized === undefined || optimized.isLoading || (optimized.isCreating && !timeDiff)) {
      return (
        <div className={styles.optimizerEmpty}>
          <div className={styles.loading}>
            <LoadingIndicator
              style={{
                margin: "0px",
                marginTop: "-20%",
                marginBottom: "50px",
                transform: "scale(1.75)"
              }}
            />
            <div className={styles.loadMsg}>
              {optimized && optimized.isCreating ? "Training AI Models..." : "Loading AI Models..."}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.results}>
        <div style={{ padding: "20px", paddingBottom: "0px" }}>
          <ProjectHelpContainer title={"Test Predictions to Validate Model Behavior"}>
            <ProjectHelpItem type={"magic"}>
              {"Evaluate the models performance by selecting different attributes and reviewing the prediction. "}
            </ProjectHelpItem>
            <ProjectHelpItem type={"listGrey"}>
              {
                "The “Optimize by changing” picklist will create a prediction that ranks each value’s influence of the variable you selected."
              }
            </ProjectHelpItem>
            {/*
            <ProjectHelpItem type={"csv"}>
              {
                "Use the bulk score CSV option if you want to evaluate the models predictions on an entire CSV. "
              }
            </ProjectHelpItem>
            */}
          </ProjectHelpContainer>
        </div>
        <div className={styles.resultsContent}>
          <div className={styles.rightContent}>{this.renderWhatIf()}</div>
        </div>
      </div>
    );
  }
}
